var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col align-self-end px-0" },
    [
      _vm.bannerLabel !== ""
        ? _c("div", [
            _c("p", {
              staticClass: "ob1-tag ob1-tag-primary",
              domProps: { innerHTML: _vm._s(_vm.bannerLabel) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.contractInfos
        ? _c("contract-phone-lines", {
            staticClass: "mt-1 mt-md-0 mb-1",
            attrs: { "contract-infos": _vm.contractInfos },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h4", {
        staticClass: "m-0",
        attrs: {
          "th:classappend": "${isShopSosh} ? 'text-dark' : 'text-white'",
        },
        domProps: { textContent: _vm._s(_vm.label) },
      }),
      _vm._v(" "),
      _c("ob1-prix-offre", {
        attrs: {
          duration: _vm.priceBlock.prixDTO.duration,
          "initial-price": _vm.priceBlock.prixDTO.initialPrice,
          price: _vm.priceBlock.prixDTO.price,
          "price-details": _vm.priceBlock.prixDTO.priceDetails,
          "show-by-month": _vm.priceBlock.prixDTO.showByMonth,
          "show-from": _vm.priceBlock.prixDTO.showFrom,
          "show-promo-duration": _vm.priceBlock.prixDTO.showPromoDuration,
          "price-label": _vm.priceBlock.priceLabel,
          "custom-promo-duration": "text-gray3 d-inline-block",
          "custom-commitment": "text-gray3",
        },
      }),
      _vm._v(" "),
      _c("ob1-separateur", { staticClass: "my-1" }),
      _vm._v(" "),
      _vm._l(_vm.attributes, function (attribute) {
        return _c(
          "p",
          { key: attribute.picto, staticClass: "d-flex align-items-center" },
          [
            _c("span", {
              class: "icon " + attribute.picto,
              staticStyle: { "font-size": "1.3rem", "margin-right": "5px" },
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(attribute.description))]),
          ]
        )
      }),
      _vm._v(" "),
      _c("ob1-boutons", {
        staticClass: "my-1",
        attrs: {
          label: _vm.buttonLabel,
          "is-button": true,
          "is-disabled": _vm.nextUrl === null,
          "is-primary": "",
        },
        on: { "ob1-boutons-click": _vm.goToNextUrl },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }